import { render } from "./MultiClickable.vue?vue&type=template&id=0c162e98"
import script from "./MultiClickable.vue?vue&type=script&lang=js"
export * from "./MultiClickable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__